'use client'

import s from './style.module.css'
import Image from 'next/image'
import CometLink from '@app/components/custom-links/comet-link'
import {LayoutEvent} from '@app/[lang]/(common-header-footer)/(home)/events'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import clsx from 'clsx'

type Props = {
  href: string
  text: string
  order?: number
  layout: string
}

const ViewAllLink = ({href, text, order, layout}: Props) => {
  return (
    <CometLink
      href={href}
      className={clsx(s.view_all_container, 'group')}
      onClick={() => {
        triggerAnalytics(LayoutEvent.ViewAllClicked, {
          layout,
          order,
        }).sendAll()
      }}
    >
      <span className={s.view_all_text}>{text}</span>
      <Image
        src='https://static.gamezop.com/comet/assets/img2/view_all_arrow.svg'
        alt='view all arrow'
        height={12}
        width={12}
        className={clsx(s.view_all_arrow, 'group-hover:translate-x-3 ease-in-out duration-200')}
      />
    </CometLink>
  )
}

export default ViewAllLink
